import React from 'react';

import { useIsMobile } from '@sravni/react-utils';

import { useProductData } from '../../hooks/useProductData';

import { Card } from './components/Card';

export const ProductBlock = ({ product, productTag, organization }) => {
  const isMobile = useIsMobile();

  const productData = useProductData({ type: productTag, item: product, organization });

  return (
    <>
      {product && productData && (
        <Card isMobile={isMobile} item={product} type={productTag} organization={organization} />
      )}
    </>
  );
};
